<h2 mat-dialog-title appLocalizationPopupDirective [localizationCode]="'RequestTimeOff'">
    {{ 'RequestTimeOff' | translate: {Default: "Request Time Off"} }}
</h2>

<mat-dialog-content>
    <ng-container *ngIf="!form; else loaded">
        <ngx-skeleton-loader
            count="5"
            [theme]="{
                'height.px': 50
            }"
        ></ngx-skeleton-loader>
    </ng-container>

    <ng-template #loaded>
        <div class="working-hours-container">
            <ngx-skeleton-loader
                *ngIf="loadingWorkingHours"
                count="1"
                [theme]="{
                    height: '50px',
                    width: '100%'
                }"
            ></ngx-skeleton-loader>

            <div
                class="page-description-section"
                *ngIf="!loadingWorkingHours && workingHours"
                role="status"
                aria-live="polite"
                aria-atomic="true"
            >
                This time off request is for {{calculatedWorkingHours}} working hour(s)
            </div>
        </div>

        <form [formGroup]="form">
            <mat-form-field appearance="fill" appLocalizationPopupDirective [localizationCode]="'RequestTimeOff-From'">
                <mat-label>
                    {{ 'RequestTimeOff-From' | translate: {Default: "From"} }}
                </mat-label>

                <input matInput [matDatepicker]="frompicker" formControlName="from">
                <span fxLayout="row" matSuffix>
                    <mat-datepicker-toggle [for]="frompicker"></mat-datepicker-toggle>
                </span>
                <mat-datepicker #frompicker></mat-datepicker>
                <mat-error *ngIf="form.get('from').hasError('required')">
                    {{ 'RequestTimeOff-From' | translate: {Default: "From"} }} {{ 'IsRequired' | translate: {Default: "is required"} }}
                </mat-error>
                <mat-error *ngIf="form.get('from').hasError('matDatepickerParse')">
                    {{ 'EnterValidDate' | translate: {Default: "Enter a valid date"} }}
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" appLocalizationPopupDirective [localizationCode]="'RequestTimeOff-To'">
                <mat-label>
                    {{ 'RequestTimeOff-To' | translate: {Default: "To"} }}
                </mat-label>

                <input matInput [min]="fromValue" [matDatepicker]="topicker" formControlName="to">
                <span fxLayout="row" matSuffix>
                    <mat-datepicker-toggle [for]="topicker"></mat-datepicker-toggle>
                </span>
                <mat-datepicker #topicker></mat-datepicker>

                <mat-error *ngIf="form.get('to').hasError('matDatepickerMin')" appLocalizationPopupDirective [localizationCode]="'MustBeAfterFrom'">
                    {{ 'MustBeAfterFrom' | translate: {Default: "Must be same or after From date"} }}
                </mat-error>
                <mat-error *ngIf="form.get('to').hasError('required')">
                    {{ 'RequestTimeOff-To' | translate: {Default: "To"} }} {{ 'IsRequired' | translate: {Default: "is required"} }}
                </mat-error>
                <mat-error *ngIf="form.get('to').hasError('matDatepickerParse')">
                    {{ 'EnterValidDate' | translate: {Default: "Enter a valid date"} }}
                </mat-error>
            </mat-form-field>

            <div class="slide-toggle-container" *ngIf="fromValue != null && fromValue !== '' && fromValue === toValue" >
                <mat-slide-toggle setColor="primaryColour" formControlName="halfDay" appLocalizationPopupDirective [localizationCode]="'RequestTimeOff-HalfDay'">
                    {{ 'RequestTimeOff-HalfDay' | translate: {Default: "Half Day"} }}
                </mat-slide-toggle>
            </div>


            <div class="slide-toggle-container" *ngIf="fromValue != null && fromValue !== '' && fromValue === toValue">
                <mat-slide-toggle setColor="primaryColour"formControlName="setTime" appLocalizationPopupDirective [localizationCode]="'RequestTimeOff-SetTime'">
                    {{ 'RequestTimeOff-SetTime' | translate: {Default: "Set Time"} }}
                </mat-slide-toggle>
            </div>

            <ng-container *ngIf="form.controls.setTime.value === true">
                <mat-form-field appearance="fill" appLocalizationPopupDirective [localizationCode]="'RequestTimeOff-StartTime'">
                    <mat-label>{{ 'RequestTimeOff-StartTime' | translate: {Default: "Start Time"} }}</mat-label>
                    <input
                        matInput
                        aria-label="start time"
                        [ngxTimepicker]="startTime"
                        [format]="24"
                        formControlName="fromTime"
                    />
                    <ngx-material-timepicker #startTime>
                    </ngx-material-timepicker>
                    <mat-error *ngIf="form.get('fromTime').hasError('required')">
                        {{ 'RequestTimeOff-StartTime' | translate: {Default: "Start Time"} }} {{ 'IsRequired' | translate: {Default: "is required"} }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" appLocalizationPopupDirective [localizationCode]="'RequestTimeOff-EndTime'">
                    <mat-label>{{ 'RequestTimeOff-EndTime' | translate: {Default: "End Time"} }}</mat-label>
                    <input
                        matInput
                        aria-label="end time"
                        [ngxTimepicker]="endTime"
                        [format]="24"
                        formControlName="toTime"
                    />
                    <ngx-material-timepicker #endTime>
                    </ngx-material-timepicker>
                    <mat-error *ngIf="form.get('toTime').hasError('required')">
                        {{ 'RequestTimeOff-EndTime' | translate: {Default: "End Time"} }} {{ 'IsRequired' | translate: {Default: "is required"} }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" appLocalizationPopupDirective [localizationCode]="'RequestTimeOff-Hours'">
                    <mat-label>
                        {{ 'RequestTimeOff-Hours' | translate: {Default: "Hours"} }}
                    </mat-label>

                    <input matInput type="number" min="0.5" max="24" formControlName="hours">
                    <mat-error *ngIf="form.get('hours').hasError('required')">
                        {{ 'RequestTimeOff-Hours' | translate: {Default: "Hours"} }} {{ 'IsRequired' | translate: {Default: "is required"} }}
                    </mat-error>
                </mat-form-field>

            </ng-container>

            <mat-form-field appearance="fill" appLocalizationPopupDirective [localizationCode]="'RequestTimeOff-Comments'">
                <mat-label>
                    {{ 'RequestTimeOff-Comments' | translate: {Default: "Comments"} }}
                </mat-label>

                <textarea matInput formControlName="comments"></textarea>
            </mat-form-field>
        </form>
    </ng-template>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-stroked-button class="close" appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="submitForm()">{{ 'Save' | translate: {Default: "Save"} }}</button>
</mat-dialog-actions>
